var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"64px 30px 64px 30px"},attrs:{"id":"backend_wrapper"}},[_c('router-view',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }